import React, { Component } from "react";
import Button from "../../Button/Button";
import "./BackNext.css";

class BackNext extends Component {
	// Renders back and next buttons for onboarding flow
	render() {
		return (
			<div className="back-next">
				{this.props.back === true && (
					<button
						className="back-btn"
						onClick={() => this.props.backOnboardingBuyer()}
					>
						&#8249; BACK
					</button>
				)}
				{this.props.next === true && (
					<Button label="Next" onClick={e => this.props.nextOnboardingBuyer(e)} />
				)}
			</div>
		);
	}
}

export default BackNext;


// WEBPACK FOOTER //
// ./src/components/BuyerList/BackNext/BackNext.js